var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfilePicEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1651_140718",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1651_140718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 15.8333H5.85417L14 7.6875L12.8125 6.5L4.66667 14.6458V15.8333ZM3 17.5V13.9583L14 2.97917C14.1667 2.82639 14.3507 2.70833 14.5521 2.625C14.7535 2.54167 14.9653 2.5 15.1875 2.5C15.4097 2.5 15.625 2.54167 15.8333 2.625C16.0417 2.70833 16.2222 2.83333 16.375 3L17.5208 4.16667C17.6875 4.31944 17.809 4.5 17.8854 4.70833C17.9618 4.91667 18 5.125 18 5.33333C18 5.55556 17.9618 5.76736 17.8854 5.96875C17.809 6.17014 17.6875 6.35417 17.5208 6.52083L6.54167 17.5H3ZM13.3958 7.10417L12.8125 6.5L14 7.6875L13.3958 7.10417Z",
    fill: "#383842"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePicEdit);
export default __webpack_public_path__ + "static/media/profile-pic-edit.f5af8d317465081f807e077ccdd173ea.svg";
export { ForwardRef as ReactComponent };